import * as firebase from 'firebase/app';
import { base64ImageToBlob } from '../lib/imageFunctions';
import "@firebase/firestore";
import "@firebase/auth";
import "@firebase/storage";


/*
Dont for get to put the "Authorised domains" .../authentication/providers in firebase console
*/


const config = {
  apiKey: "AIzaSyBzf_kzOLzg3IhBuqfq1u9RxxHcAEKmEwQ",
  authDomain: "networkbuddy.com.au",
  databaseURL: "https://network-buddy-v1.firebaseio.com",
  projectId: "network-buddy-v1",
  storageBucket: "network-buddy-v1.appspot.com",
  messagingSenderId: "1028877891870"
};

export const firebaseApp = firebase.initializeApp(config);
export const firestore = firebaseApp.firestore(firebaseApp);
export const auth = firebaseApp.auth();
export const facebookAuth = new firebase.auth.FacebookAuthProvider();

export const authUserUidStorageKey = 'AUTH_USER_UID_LOCAL_STORAGE';
export const authUserManageMyEventsStorageKey = 'AUTH_USER_MANAGE_MY_EVENTS_LOCAL_STORAGE';


export const authUserUId = () => {
  return window.localStorage.getItem(authUserUidStorageKey);
}

export const manageMyEvents = () => {
  return window.localStorage.getItem(authUserManageMyEventsStorageKey);
}

export function getContinueUrl(url) {
  return getParameterByName('continueUrl', url)
}

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export function signOut() {
  auth.signOut()
  .then(function() {
    clearAuthCache();
    window.location.reload();
  }).catch(function(error) {
    console.log("Unable to sign out: " + error);
  });
}

export function setAuthCache(authUser) {
  window.localStorage.setItem(authUserUidStorageKey, authUser.uid);
}

export async function loadUserById(id) {
  try {
    var user = await firestore.collection("users").doc(id).get()
    if (user.exists)
      return user.data()
    return undefined
  } catch (e) {
    return undefined
  }
}

export async function validUserProfile() {
  if (!auth.currentUser) return
  if (!auth.currentUser.uid) return
  try {
    console.log('v1')
    var id = auth.currentUser.uid;
    console.log('v2')
    var user = await loadUserById(id)
    console.log('v3', user)
  } catch (e) {
    console.log('v fail')
    return false
  }
  if (user === undefined)
    return false
  else {
    if(!(user.givenNames && user.givenNames.length > 2)) return false
    if(!(user.familyName && user.familyName.length > 2)) return false
    if(!(user.contactNumber && user.contactNumber.length > 7)) return false
    if(!(user.businessName && user.businessName.length > 2)) return false
    console.log('v9', user)
    return true
  }
}

export async function setUser(user) {
  if (!auth.currentUser) return
  if (!auth.currentUser.uid) return

  var id = auth.currentUser.uid;

  if (!user) return
  const currentUser = await loadUserById(id)
  var data = {}

  if (currentUser === undefined) {
    data = user
    await firestore.collection("users").doc(id).set(data)

  } else {
    data = Object.assign({}, currentUser, user)
    await firestore.collection("users").doc(id).update(data)
  }
  return data

}


export function setManageMyEvents() {
  firestore.collection("users").doc(authUserUId())
  .get()
  .then(function(snapshot) {
    let user = snapshot.data();
    if (user.manageMyEvents === true) {
      window.localStorage.setItem(authUserManageMyEventsStorageKey, true);
    } else {
      window.localStorage.removeItem(authUserManageMyEventsStorageKey);
    }
  })
  .catch(function (err) {
    console.log(err);
    window.localStorage.removeItem(authUserManageMyEventsStorageKey);
  })
}

export function clearAuthCache() {
  console.log("Clear Auth cache");
  window.localStorage.removeItem(authUserUidStorageKey);
  window.localStorage.removeItem(authUserManageMyEventsStorageKey);
}

function loadSnapShot(snapshot) {
  var lst = []
  snapshot.forEach(doc => {
    var event = doc.data();
    event.id = doc.id;
    lst.push(event);
  });
  return lst;
}

export function archivedEvents(limit, element, direction) {
  let date = new Date(Date.now());
  return new Promise((resolve, reject) => {
    if ((element) && (direction)) {
      firestore.collection("events")
      .orderBy('startDate', 'desc')
      .orderBy('_c', 'desc')
      .startAt(element.startDate, element._c)
      .limit(limit)
      .get()
      .then(snapshot => {
        var lst = loadSnapShot(snapshot)
        resolve(lst);
        return;
      })
      .catch(err => {
        console.log(err)
        reject()
      });
    } else {
      firestore.collection("events")
      .where("startDate", "<", date)
      .orderBy('startDate', 'desc')
      .orderBy('_c', 'desc')
      .limit(limit)
      .get()
      .then(snapshot => {
        var lst = loadSnapShot(snapshot)
        resolve(lst);
        return;
      })
      .catch(err => {
        console.log(err)
        reject()
      });
    }

  });
}

export function draftEvents(limit) {
  //let date = new Date(Date.now());
  return new Promise((resolve, reject) => {
    firestore.collection("events")
    .where("published", "==", false)
    .orderBy("startDate")
    .limit(limit)
    .get()
    .then(snapshot => {
      var lst = []
      snapshot.forEach(doc => {
        var event = doc.data();
        event.id = doc.id;
        lst.push(event);
      });
      resolve(lst);
      return;
    })
    .catch(err => reject());
  });
}

export function upcomingEvents(limit) {
  let date = new Date(Date.now());
  return new Promise((resolve, reject) => {
    firestore.collection("events")
    .where("startDate", ">=", date)
    .where("published", "==", true)
    .orderBy("startDate")
    .limit(limit)
    .get()
    .then(snapshot => {
      var lst = []
      snapshot.forEach(doc => {
        var event = doc.data();
        event.id = doc.id;
        lst.push(event);
      });
      resolve(lst);
      return;
    })
    .catch(err => reject());
  });
}

export function getEvent(id) {
  return new Promise((resolve, reject) => {
    firestore.collection("events").doc(id)
      .get()
      .then(function(snapshot) {
        var event = snapshot.data();
        event.id = id;
        resolve(event);
        return;
      })
      .catch(err => reject(err));
    });
}

/* Get the download url from an Image */
export function getImageSrc(imageName) {
  return new Promise((resolve, reject) => {
    if ((imageName === "") || (imageName === undefined)) {
      resolve();
      return;
    }
    var pathUrl = "images/" + imageName;
    var storageRef = firebase.storage().ref();
    storageRef.child(pathUrl)
      .getDownloadURL()
      .then((url) => {
        resolve(url);
        return;
      })
      .catch((err) => {
        console.log("getImageSrc Err" + JSON.stringify(err));
        console.log(imageName);
        reject(err);
        return;
      });
  })
}

export function checkAttend(eventId) {
  console.log("checkAttend")
  return new Promise((resolve, reject) => {
    if (!authUserUId()) {
      resolve(false);
      return;
    }
    firestore.collection("attend")
    .where("eventId", "==", eventId)
    .where("uId", "==", authUserUId())
    .limit(1)
    .get()
    .then(function(snapshot) {
      if (snapshot.docs[0]) {
       resolve(true);
       return;
      } else {
       resolve(false);
       return;
      }
    });
  });
}

//Request a buddy
/*
Attend status
100 Request A Buddy
200 Invited
300 Not
400 Maybe
500 Attending
600 Attending as Buddy
*/
export function requestABuddy(event) {
  if (!authUserUId()) return false

  return new Promise((resolve, reject) => {
    checkAttend(event.id)
    .then(function(attend) {
      if (!attend) {
        const msTime = new Date().getTime();
        const data = {
          eventId: event.id,
          eventTitle: event.title,
          eventStartDate: event.startDate,
          status: "100",
          uId: authUserUId(),
          _cUId: authUserUId(),
          _c: msTime,
          _uUId: authUserUId(),
          _u: msTime
        }
        firestore.collection("attend")
        .add(data)
        .then(function() {
          resolve(true);
          return;
        });
      } else {
        resolve(false);
        return;
      }
    })
    .catch(e => {
      console.log(e);
      resolve(false)
    })
  });
}


/* Save the image to firebase store*/
async function _saveImage(imageStorageName, imageData) {
  if (!imageData) {
      throw new Error("Unable to _saveImage, imageData is undefined");
  }

  let blob = base64ImageToBlob(imageData);

  console.log("Save New Image");

  var storageRef = firebase.storage().ref();
  var imagesRef = storageRef.child("images/" + imageStorageName);
  var metadata = {
    //contentType: imageData.type,
    contentType: 'image/jpeg'
  };
  try {
    await imagesRef.put(blob, metadata)
      .then(function(snapshot) {
        console.log('Finished Saving!');
      })
      .catch(err => console.log(err));
  } catch (e) {
      console.log(e)
  } finally {

  }
}

export function generateImageName() {
  const uuidv4 = require('uuid/v4');
  return uuidv4();
}

/* Save an Event */
export function saveEvent(id, event, featureImageData) {
  return new Promise(async (resolve, reject) => {
    /* Save Image */
    if (featureImageData) {
      if (!event.featureImageStorageName) {
        throw new Error("Image name cannot be empty")
      }
      _saveImage(event.featureImageStorageName, featureImageData);
    }

    /*Get Image Src*/
    event.featureImageSrc = await getImageSrc(event.featureImageStorageName)

    var msTime = new Date().getTime();
    if (!event._c) {
      event._c = msTime;
    }
    if (!event._cUid) {
      event._cUId = authUserUId();
    }
    event._uUId = authUserUId();
    event._u = msTime;

    console.log("Saving")
    /* Save JSON Data */
    if (id) {
      firestore.collection("events").doc(id)
      .set(event)
      .then(function() {
        resolve();
        return;
      })
    } else {
      firestore.collection("events")
      .add(event)
      .then(ref => {
        resolve(ref.id);
        return;
      });
    }

  });
}

export async function saveUserCapturedEvent(event) {
  if (!auth.currentUser) return
  if (!auth.currentUser.uid) return

  let ref = await firestore.collection("events").add(event);
  console.log("EventID:", ref.id)
  return "SUMMITTED"
}

/*
service cloud.firestore {
  match /databases/{database}/documents {
   	// Match all documents, recursively, with a wildcard and the "=**" recursive modifier
    function canRead() {
    	return request.auth != null;
    }

    function canUpdate() {
    	return false;
    }

    match /idents/{document} {
      allow read: if false;
      allow update: if false;
    }

    match /attend/{document} {
    	allow read;
			allow create: if
      							request.auth != null;
      allow update: if
      							request.auth != null;

    }

    match /events/{document} {
    	allow read;
     	allow write: if
      						request.auth != null
                  && request.resource.data.byUId == request.auth.uid
                  && get(/databases/$(database)/documents/users/$(request.auth.uid)).data.auth == true;
    }

    match /users/{document} {
    	allow read: if
      						request.auth != null
                  && get(/databases/$(database)/documents/users/$(request.auth.uid)).data.auth == true;
			allow create: if
      							request.auth != null;
      allow update: if
      							request.auth != null;

    }
  }
}
*/



// WEBPACK FOOTER //
// ./src/api/FirebaseAPI.js